import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

import { Container as ItemActionsContainer } from "app/modules/project-from-comparison/components/ItemActions/styles";

const { carbon } = colorsPalettes;

export const Item = styled.li`
    display: flex;
    align-items: center;
    gap: 4px;
    height: 32px;

    &:hover {
        ${ItemActionsContainer} {
            opacity: 1;
        }
    }
`;

export const Text = styled.span<{ isPrimary: boolean }>`
    display: flex;
    align-items: center;
    gap: 4px;
    ${setFontVariant("body2", `${carbon[500]}CC`)};
`;

export const Name = styled.span<{ isPrimary: boolean }>`
    max-width: ${({ isPrimary }) => (isPrimary ? "130px" : "240px")};

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const IconContainer = styled(Flex)`
    width: 20px;
    height: 20px;
    border-radius: 4px;
    border: 1px solid ${carbon[50]};
    background: ${carbon[0]};

    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

export const Icon = styled.img`
    border-radius: 2px;
    width: 16px;
    height: 16px;
`;

export const VersusText = styled.div`
    ${setFontVariant("chip1", carbon[400])};
    display: flex;
    align-items: center;
    height: 32px;
    flex-shrink: 0;
`;
